import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
//import { db } from "../firebase";
import store from "../store";
import {
  i18n,
  loadLocale,
  PREFIXED_LOCALES,
  splitLocalePath,
  DEFAULT_LOCALE,
  localePath,
  saveLanguagePreference,
  getLanguagePreference,
} from "@/i18n";
import { installAppUpdates } from "@/utils/appUpdates";
import Lisbon3DayItinerary from '@/data/posts/lisbon-3-day-itinerary'

import { dashboardRouteFor, isSignedIn as hasSignedInUser } from "../utils/accountHome";
import { /* UsersMutations */ UsersStates, AffiliatesActions, AffiliatesGetters } from "../store/Storetypes";

const CreateTour = () => import('@/components/CreateTour.vue');
const CreateEvent = () => import('@/components/CreateEvent.vue');
const CreateTicket = () => import('@/components/CreateTicket.vue');
const Dashboard = () => import('@/Guiders/Dashboard.vue');
const SchedulePlanner = () => import('@/Guiders/SchedulePlanner.vue');
const CreateGroup = () => import('@/Guiders/CreateGroup.vue');
const Settings = () => import('@/Settings/Settings.vue');
const GeneralInfo = () => import('@/Settings/GeneralInfo.vue');
const ChangePassword = () => import('@/Settings/ChangePassword.vue');
const TicketScanner = () => import('@/components/TicketScanner.vue');
const CompanyDashboard = () => import('@/Company/Dashboard.vue');
const AddEmployee = () => import('@/Company/AddEmployee.vue');
const EmployeesPage = () => import('@/Company/EmployeesPage.vue');
const ManageEmployee = () => import('@/Company/ManageEmployee.vue');
const AffiliateProgram = () => import('@/Admin/AffiliateProgram.vue');
const AdminDashboard = () => import('@/Admin/Dashboard.vue');
const ManageGuiders = () => import('@/Admin/ManageGuiders.vue');
const ManagePayments = () => import('@/Admin/ManagePayments.vue');
const UpcomingActivitiesPage = () => import('@/Admin/UpcomingActivitiesPage.vue');
const GuiderDetails = () => import('@/Admin/GuiderDetails.vue');
const CompanyProfile = () => import('@/Company/CompanyProfile.vue');
const AffiliatesPage = () => import('@/components/AffiliatesPage.vue');
const TourReview = () => import('@/components/TourReview.vue');
const RegistrationForm = () => import('@/Company/RegistrationForm.vue');
const TranferRegistrationForm = () => import('@/Company/TranferRegistrationForm.vue');
const StripeRefresh = () => import('@/components/StripeRefresh.vue');
const FeedbackForm = () => import('@/Company/FeedbackForm.vue');
const RegisteredPrivateGuideForm = () => import('@/Company/RegisteredPrivateGuideForm.vue');
const NotFound = () => import('@/components/NotFound.vue');

export const routes = [
  {
    path: "/blog/best-things-to-see-and-do-in-sintra-in-a-day",
    name: "guide-sintra",
    component: () => import(/* webpackChunkName: "login" */"../Blog/sintra"),
    meta: {
      title: 'Best Things to See and Do in Sintra in a Day | Guiders Blog',
      description: 'Complete guide to visiting Sintra in one day. Discover Pena Palace, Quinta da Regaleira, and more with our expert tips.',
      keywords: 'sintra day trip, pena palace, sintra portugal, sintra tours, sintra guide',
      canonical: 'https://guiders.pt/blog/best-things-to-see-and-do-in-sintra-in-a-day',
      robots: 'index, follow',
      og: {
        type: 'article',
        title: 'Best Things to See and Do in Sintra in a Day',
        description: 'Complete Sintra day trip guide',
        url: 'https://guiders.pt/blog/best-things-to-see-and-do-in-sintra-in-a-day'
      }
    }
  },
  {
    path: "/blog/10-best-things-to-do-in-lisbon-in-2024",
    name: "10-best-things-to-do-in-lisbon-in-2024",
    component: () => import(/* webpackChunkName: "login" */"../Blog/lisbon"),
    meta: {
      title: '10 Best Things to Do in Lisbon in 2024 | Guiders Blog',
      description: 'Discover the top 10 must-see attractions and experiences in Lisbon for 2024. From historic neighborhoods to local cuisine.',
      keywords: 'lisbon attractions, things to do in lisbon, lisbon travel guide, lisbon 2024',
      canonical: 'https://guiders.pt/blog/10-best-things-to-do-in-lisbon-in-2024',
      robots: 'index, follow',
      og: {
        type: 'article',
        title: '10 Best Things to Do in Lisbon in 2024',
        description: 'Top Lisbon attractions and experiences for 2024',
        url: 'https://guiders.pt/blog/10-best-things-to-do-in-lisbon-in-2024'
      }
    }
  },
  {
    path: "/blog/your-guide-to-santos-populares-portugal-s-beloved-june-celebrations",
    // Old URL (apostrophes make messy links); kept so existing links work
    alias: "/blog/your-guide-to-santos-populares-portugal's-beloved-june-celebrations",
    name: "your-guide-to-santos-populares-portugal's-beloved-june-celebrations",
    component: () => import(/* webpackChunkName: "login" */"../Blog/santospopulares"),
    meta: {
      title: 'Santos Populares: Portugal\'s Beloved June Celebrations | Guiders Blog',
      description: 'Your complete guide to Santos Populares, Portugal\'s vibrant June festivals celebrating St. Anthony, St. John, and St. Peter.',
      keywords: 'santos populares, portugal festivals, june festivals portugal, lisbon festivals',
      canonical: 'https://guiders.pt/blog/your-guide-to-santos-populares-portugal-s-beloved-june-celebrations',
      robots: 'index, follow',
      og: {
        type: 'article',
        title: 'Santos Populares: Portugal\'s Beloved June Celebrations',
        description: 'Guide to Portugal\'s June festivals',
        url: 'https://guiders.pt/blog/your-guide-to-santos-populares-portugal-s-beloved-june-celebrations'
      }
    }
  },
  {
    path: "/login-ed",
    name: "login",
    // Same login page for everyone (the old Login.vue signed resellers in
    // against the guides table); this address opens on the Guide tab
    component: () => import(/* webpackChunkName: "login" */"../components/LoginPage.vue"),
    meta: {
      requiresUnauth: true,
      title: 'Login | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/login-ed'
    },
  },
  {
    path: "/login",
    name: "login-form",
    component: () => import(/* webpackChunkName: "login" */"../components/LoginPage.vue"),
    meta: {
      requiresUnauth: true,
      title: 'Login | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/login'
    },
  },
  // ---------- Private guide marketplace ----------
  {
    path: "/guide-portal/login",
    name: "guide-portal-login",
    component: () => import(/* webpackChunkName: "guide-portal" */"../components/guidePortal/GuidePortalAuth.vue"),
    meta: { requiresUnauth: true, title: 'Guide portal | Guiders', robots: 'noindex, nofollow' },
  },
  {
    // No requiresUnauth: people with another Guiders account can still join
    path: "/guide-portal/join",
    name: "guide-portal-join",
    component: () => import(/* webpackChunkName: "guide-portal" */"../components/guidePortal/GuidePortalAuth.vue"),
    meta: { title: 'Guide with Guiders | Guiders', robots: 'noindex, nofollow' },
  },
  {
    path: "/guide-portal",
    name: "guide-portal",
    component: () => import(/* webpackChunkName: "guide-portal" */"../components/guidePortal/GuidePortal.vue"),
    meta: { roles: ["privateGuide"], loginRoute: "guide-portal-login", title: 'Guide portal | Guiders', robots: 'noindex, nofollow' },
  },
  // Pedidos Coreanos (tuk-tuk tours staffed through the guides' WhatsApp group)
  {
    path: "/admin/tuk-guias",
    name: "tuk-guides",
    component: () => import(/* webpackChunkName: "coreanos" */"../Admin/coreanos/TukGuides.vue"),
    meta: { requiresAuth: true, isAdmin: true, title: 'Guias | Pedidos Coreanos', robots: 'noindex, nofollow' },
  },
  // Old guide links (/c, /c/XXXX) → /coreanos
  { path: "/c", redirect: "/coreanos" },
  { path: "/c/:shortId", redirect: (to) => `/coreanos/${to.params.shortId}` },
  {
    // Guide's personal page: their tours and tours looking for people
    path: "/coreanos",
    name: "coreanos-guide-home",
    component: () => import(/* webpackChunkName: "coreanos-guide" */"../Admin/coreanos/GuideTour.vue"),
    meta: { title: 'Os meus tours | Guiders', robots: 'noindex, nofollow' },
  },
  {
    // Guides open this from the WhatsApp group (phone sign-in on the page)
    path: "/coreanos/:shortId",
    name: "coreanos-tour",
    component: () => import(/* webpackChunkName: "coreanos-guide" */"../Admin/coreanos/GuideTour.vue"),
    meta: { title: 'Tour Coreanos | Guiders', robots: 'noindex, nofollow' },
  },
  {
    path: "/admin/coreanos",
    name: "coreanos",
    component: () => import(/* webpackChunkName: "coreanos" */"../Admin/coreanos/CoreanosList.vue"),
    meta: { requiresAuth: true, isAdmin: true, title: 'Pedidos | Pedidos Coreanos', robots: 'noindex, nofollow' },
  },
  {
    path: "/admin/coreanos/novo",
    name: "coreanos-new",
    component: () => import(/* webpackChunkName: "coreanos" */"../Admin/coreanos/CoreanosForm.vue"),
    meta: { requiresAuth: true, isAdmin: true, title: 'Novo pedido | Pedidos Coreanos', robots: 'noindex, nofollow' },
  },
  {
    path: "/admin/coreanos/:id/editar",
    name: "coreanos-edit",
    component: () => import(/* webpackChunkName: "coreanos" */"../Admin/coreanos/CoreanosForm.vue"),
    meta: { requiresAuth: true, isAdmin: true, title: 'Editar pedido | Pedidos Coreanos', robots: 'noindex, nofollow' },
  },
  {
    path: "/admin/coreanos/:id",
    name: "coreanos-detail",
    component: () => import(/* webpackChunkName: "coreanos" */"../Admin/coreanos/CoreanosDetail.vue"),
    meta: { requiresAuth: true, isAdmin: true, title: 'Pedido | Pedidos Coreanos', robots: 'noindex, nofollow' },
  },
  {
    path: "/guide-portal/invoices",
    name: "guide-portal-invoices",
    component: () => import(/* webpackChunkName: "guide-portal" */"../components/guidePortal/GuideInvoices.vue"),
    meta: { roles: ["privateGuide"], loginRoute: "guide-portal-login", title: 'Invoices | Guide portal', robots: 'noindex, nofollow' },
  },
  {
    path: "/guide-portal/profile",
    name: "guide-portal-profile",
    component: () => import(/* webpackChunkName: "guide-portal" */"../components/guidePortal/GuideProfile.vue"),
    meta: { roles: ["privateGuide"], loginRoute: "guide-portal-login", title: 'My profile | Guide portal', robots: 'noindex, nofollow' },
  },
  {
    path: "/admin/guide-requests",
    name: "admin-guide-requests",
    component: () => import(/* webpackChunkName: "guide-admin" */"../Admin/GuideRequests.vue"),
    meta: { requiresAuth: true, isAdmin: true, title: 'Guide requests | Admin', robots: 'noindex, nofollow' },
  },
  {
    path: "/admin/private-guides",
    name: "admin-private-guides",
    component: () => import(/* webpackChunkName: "guide-admin" */"../Admin/PrivateGuides.vue"),
    meta: { requiresAuth: true, isAdmin: true, title: 'Private guides | Admin', robots: 'noindex, nofollow' },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import(/* webpackChunkName: "login" */"../components/auth/ForgotPassword.vue"),
    meta: {
      requiresUnauth: true,
      title: 'Reset your password | Guiders',
      robots: 'noindex, nofollow',
    },
  },
  {
    // Links in account emails: reset password, confirm email, sign-in link
    path: "/auth/action",
    name: "auth-action",
    component: () => import(/* webpackChunkName: "login" */"../components/auth/AuthAction.vue"),
    meta: {
      title: 'Guiders account',
      robots: 'noindex, nofollow',
    },
  },
  {
    path: "/vendor/login",
    name: "vendor-login",
    // Opens the shared login page on the Reseller tab
    component: () => import(/* webpackChunkName: "login" */"../components/LoginPage.vue"),
    meta: {
      requiresUnauth: true,
      title: 'Vendor Login | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/vendor/login'
    },
  },
  {
    path: "/concierge",
    name: "concierge",
    component: () => import(/* webpackChunkName: "concierge" */"../Concierge"),
    meta: {
      title: 'Travel Concierge Service | Guiders.pt',
      description: 'Get personalized travel planning assistance for your Portugal trip. Custom itineraries, private guides, and local expertise.',
      keywords: 'travel concierge portugal, personalized itineraries, private travel planning, portugal trip planning',
      canonical: 'https://guiders.pt/concierge',
      robots: 'index, follow'
    }
  },
  {
    path: "/multi-day-tours/lisbon-and-porto-7-days",
    name: "concierge",
    component: () => import(/* webpackChunkName: "concierge" */"../MultiDayTours/PageContainer"),
    meta: {
      title: 'Lisbon and Porto 7-Day Tour Package | Guiders',
      description: '7-day tour package exploring Lisbon and Porto. Experience the best of Portugal\'s two main cities with guided tours and cultural experiences.',
      keywords: 'lisbon porto tour, 7-day portugal tour, multi-day tours portugal, portugal package tours',
      canonical: 'https://guiders.pt/multi-day-tours/lisbon-and-porto-7-days',
      robots: 'index, follow'
    }
  },
  {
    path: "/concierge/quote",
    name: "quote",
    component: () => import(/* webpackChunkName: "login" */"../components/QuoteForm"),
    meta: {
      requiresUnauth: true,
      title: 'Request a Quote | Guiders Travel Concierge',
      description: 'Get a personalized quote for your Portugal trip. Custom tours, private guides, and tailored experiences.',
      canonical: 'https://guiders.pt/concierge/quote',
      robots: 'index, follow'
    },
  },
  {
    path: "/concierge/quote/success",
    name: 'quote-request-sent',
    component: () => import(/* webpackChunkName: "quote-request-sent" */"../components/QuoteRequestSent"),
    meta: {
      title: 'Quote Request Sent | Guiders',
      robots: 'noindex, follow',
      canonical: 'https://guiders.pt/concierge/quote/success'
    }
  },
  {
    path: "/live-map",
    name: 'live-drivers-map',
    component: () => import(/* webpackChunkName: "quote-request-sent" */"../components/LiveDriversMap.vue"),
    meta: {
      title: 'Live Drivers Map | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/live-map'
    }
  },
  {
    path: "/unlock",
    name: "unlock",
    component: () => import(/* webpackChunkName: "unlock" */"../Guiders/RegistrationGuard"),
    meta: {
      requiresUnauth: true,
      title: 'Unlock Account | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/unlock'
    },
  },
  // In your router.js file
  {
    path: '/driver-sales',
    name: 'driver-sales',
    component: () => import("../components/DriversSalesPage.vue"),
    meta: {
      requiresAuth: true,
      title: 'Driver Sales | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/driver-sales'
    }
  },
  {
    path: "/register",
    name: "register",
    component: () => import(/* webpackChunkName: "register" */"../components/Register"),
    meta: {
      requiresUnauth: true,
      title: 'Register | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/register'
    },
  },
  {
    path: "/guider/register",
    name: "register-guider",
    component: () => import(/* webpackChunkName: "register" */"../components/Register"),
    meta: {
      requiresUnauth: true,
      title: 'Become a Guider | Guiders.pt',
      description: 'Join Guiders as a tour guide in Portugal. Share your expertise with travelers and grow your business.',
      canonical: 'https://guiders.pt/guider/register',
      robots: 'index, follow'
    },
  },
  {
    path: "/tours/full-day-tours",
    name: "full-day-tours",
    component: () => import(/* webpackChunkName: "full-day-tours" */"../ToursByCategory/FullDayTours"),
    meta: {
      transition: 'fade',
      title: 'Full Day Tours in Lisbon | Guiders.pt',
      description: 'Explore Lisbon with our full-day guided tours. Visit historic neighborhoods, taste local cuisine, and discover hidden gems with expert guides.',
      keywords: 'full day tours lisbon, lisbon day tours, guided day tours portugal, portugal full day tours',
      canonical: 'https://guiders.pt/tours/full-day-tours',
      robots: 'index, follow',
      og: {
        title: 'Full Day Tours in Lisbon | Guiders.pt',
        description: 'Book full-day tours in Lisbon',
        url: 'https://guiders.pt/tours/full-day-tours'
      }
    },
  },
  {
    path: "/tours/tuk-tuk-tours",
    name: "tuk-tuk-tours",
    component: () => import(/* webpackChunkName: "tuk-tuk-tours" */"../ToursByCategory/TukTukTours"),
    meta: {
      transition: 'fade',
      title: 'Tuk Tuk Tours in Lisbon | Guiders.pt',
      description: 'Experience Lisbon in a fun and unique way with our tuk-tuk tours. Explore narrow streets, historic sites, and panoramic viewpoints.',
      keywords: 'tuk tuk tours lisbon, lisbon tuk tuk, electric tuk tuk tours, eco-friendly tours lisbon',
      canonical: 'https://guiders.pt/tours/tuk-tuk-tours',
      robots: 'index, follow',
      og: {
        title: 'Tuk Tuk Tours in Lisbon | Guiders.pt',
        description: 'Book tuk-tuk tours in Lisbon',
        url: 'https://guiders.pt/tours/tuk-tuk-tours'
      }
    },
  },
  {
    path: "/tours/cultural-tours",
    name: "cultural-tours",
    component: () => import(/* webpackChunkName: "cultural" */"../ToursByCategory/CulturalTours"),
    meta: {
      transition: 'fade',
      title: 'Cultural Tours in Portugal | Guiders.pt',
      description: 'Immerse yourself in Portuguese culture with our guided cultural tours. Experience local traditions, arts, and heritage.',
      keywords: 'cultural tours portugal, portugal culture tours, heritage tours, traditional portugal tours',
      canonical: 'https://guiders.pt/tours/cultural-tours',
      robots: 'index, follow',
      og: {
        title: 'Cultural Tours in Portugal | Guiders.pt',
        description: 'Book cultural tours in Portugal',
        url: 'https://guiders.pt/tours/cultural-tours'
      }
    },
  },
  {
    path: "/tours/portugal-architecture",
    name: "portugal-architecture",
    component: () => import(/* webpackChunkName: "portugal-architecture" */"../ToursByCategory/Architecture"),
    meta: {
      transition: 'fade',
      title: 'Architecture Tours in Portugal | Guiders.pt',
      description: 'Discover Portugal\'s architectural wonders from Manueline to Modernist styles. Guided tours of historic buildings and contemporary design.',
      keywords: 'architecture tours portugal, portugal architecture, historic buildings tours, architectural tours lisbon',
      canonical: 'https://guiders.pt/tours/portugal-architecture',
      robots: 'index, follow',
      og: {
        title: 'Architecture Tours in Portugal | Guiders.pt',
        description: 'Book architecture tours in Portugal',
        url: 'https://guiders.pt/tours/portugal-architecture'
      }
    },
  },
  {
    path: "/tours/historical-tours",
    name: "historical-tours",
    component: () => import(/* webpackChunkName: "historical-tours" */"../ToursByCategory/HistoricalTours"),
    meta: {
      transition: 'fade',
      title: 'Historical Tours in Portugal | Guiders.pt',
      description: 'Step back in time with our historical tours of Portugal. Explore castles, monasteries, and UNESCO World Heritage sites.',
      keywords: 'historical tours portugal, portugal history tours, castle tours, unesco tours portugal',
      canonical: 'https://guiders.pt/tours/historical-tours',
      robots: 'index, follow',
      og: {
        title: 'Historical Tours in Portugal | Guiders.pt',
        description: 'Book historical tours in Portugal',
        url: 'https://guiders.pt/tours/historical-tours'
      }
    },
  },
  {
    path: "/:companyId/guider/register",
    name: "register-employee",
    component: () => import("../components/Register"),
    meta: {
      requiresUnauth: true,
      title: 'Employee Registration | Guiders',
      robots: 'noindex, nofollow',
      canonical: (route) => `https://guiders.pt/${route.params.companyId}/guider/register`
    },
  },
  {
    path: "/vendor/:vendorId/register",
    name: "register-vendor",
    component: () => import("../Vendor/Register.vue"),
    meta: {
      requiresUnauth: true,
      title: 'Vendor Registration | Guiders',
      robots: 'noindex, nofollow',
      canonical: (route) => `https://guiders.pt/vendor/${route.params.vendorId}/register`
    },
  },
  {
    path: "/vendor/scan",
    name: "vendor-ticket-scanner",
    component: () => import("../Vendor/ScanTicket"),
    meta: {
      requiresAuth: true,
      roles: ["vendor"],
      title: 'Ticket Scanner | Vendor Dashboard',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/vendor/scan'
    }
  },
  {
    path: "/vendor/ticket/print",
    name: "print-ticket",
    // Vendor/PrintTicket.vue is an unfinished prototype (demo "Product A -
    // $10" receipt, empty QR): don't let anyone print it
    redirect: { name: "vendor-dashboard" },
    meta: {
      requiresAuth: true,
      roles: ["vendor"],
      title: 'Print Ticket | Vendor Dashboard',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/vendor/ticket/print'
    }
  },
  {
    path: "/ticket",
    name: "booking-details",
    component: () => import("../TicketDetails.vue"),
    meta: {
      ghTheme: true, // Guiders design: own header/footer, see components/home/GhPage.vue
      i18n: true, // translated: also served at /pt/ticket etc. (see below)
      title: 'Booking Details | Guiders',
      robots: 'noindex, nofollow', // personal booking page
      canonical: 'https://guiders.pt/ticket'
    }
  },
  {
    path: "/admin/activities",
    name: "manage-activities",
    component: () => import("../Admin/ManageActivities"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Manage Activities | Admin Dashboard',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/activities'
    },
  },
  {
    path: "/admin/bookings",
    name: "bookings",
    component: () => import("../Admin/BookingsSchedule"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Bookings Schedule | Admin Dashboard',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/bookings'
    },
  },
  {
    path: "/admin/vendors",
    name: "manage-vendors",
    component: () => import("../Admin/ManageVendors"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Manage Vendors | Admin Dashboard',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/vendors'
    },
  },
  {
    path: "/admin/payment-history",
    name: "admin-payment-history",
    // Admin/PaymentHistory.vue was never built (it only holds the Buefy
    // documentation's demo table): send people to the real payments page
    redirect: { name: "manage-payments" },
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Payment History | Admin Dashboard',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/payment-history'
    },
  },
  {
    path: "/settings",
    name: "settings",
    component: () => import("../Settings/Settings"),
    meta: {
      requiresAuth: true,
      title: 'Settings | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/settings'
    },
  },
  /* {
    path: "/home",
    name: "home",
    component: () => import("../components/HomePage"),
    meta: {
      title: 'Guiders.pt | Shared Tours and Activities in Lisbon, Portugal',
      description: 'Discover Lisbon with shared and private tours, tuk-tuk rides, and custom itineraries. Book your perfect Lisbon experience today!',
      keywords: 'lisbon tours, tuk-tuk tours lisbon, lisbon visitor pass, 24 hour tuk tuk, hop on hop off, flexible lisbon travel, on-demand tuk tuk, 15 minute pickup guarantee, unlimited tuk tuk rides',
      canonical: 'https://guiders.pt/home',
      robots: 'index, follow',
      og: {
        title: 'Guiders.pt | Book Tours in Lisbon',
        description: 'Discover Lisbon with our guided tours',
        url: 'https://guiders.pt/home'
      }
    }
  }, */
  /*  {
     path: "/lisbon-visitor-pass",
     name: "lisbon-visitor-pass",
     component: () => import("@/LisbonVisitorPass.vue"),
     meta: {
       title: 'Lisbon Visitor Pass | 24-Hour Hop-on Hop-off Tuk-Tuk Pass',
       description: 'Experience Lisbon with 24-hour unlimited hop-on hop-off tuk-tuk access. Call drivers to route stops - they arrive in 15 minutes max!',
       canonical: 'https://guiders.pt/lisbon-visitor-pass',
       robots: 'index, follow'
     }
   }, */
  {
    path: "/",
    name: "home",
    component: () => import("@/HomePage.vue"),
    meta: {
      ghTheme: true, // Guiders design: own header/footer, see components/home/GhPage.vue
      i18n: true, // translated: also served at /pt, /es, /de, /fr (see below)
      title: 'Lisbon Tuk Tuk Tours & Private Guides | Guiders.pt',
      description: 'Private tuk tuk tours, the hop-on hop-off Lisbon Visitor Pass from €29, licensed private guides and day trips across Portugal. Book with local experts.',
      canonical: 'https://guiders.pt/',
      robots: 'index, follow'
    }
  },
  {
    path: "/lisbon-visitor-pass",
    name: "lisbon-visitor-pass",
    component: () => import("../components/LisbonVisitorPassExplanation.vue"),
    meta: {
      ghTheme: true, // Guiders design: own header/footer, see components/home/GhPage.vue
      i18n: true, // translated: also served at /pt/lisbon-visitor-pass etc. (see below)
    },
  },

   {
    path: "/portugal-dmc",
    name: "portugal-dmc",
    component: () => import("@/PortugalDMC.vue"),
    meta: {
      ghTheme: true, // Guiders design: own header/footer, see components/home/GhPage.vue
      i18n: true,
    },
  },
  {
    // Sample multi-day programmes (data: src/data/programmes.js)
    path: "/programmes/:slug",
    name: "programme",
    component: () => import(/* webpackChunkName: "programme" */ "@/ProgrammePage.vue"),
    meta: {
      ghTheme: true, // Guiders design: own header/footer, see components/home/GhPage.vue
      i18n: true,
    },
  },
    // Translated versions: /pt, /pt/portugal-dmc, /pt/programmes/<slug>...
  {
    path: `/:lang(${PREFIXED_LOCALES.join("|")})/details/:id/:title?`,
    name: "details-lang",
    component: () => import("../components/TourPage"),
    meta: { ghTheme: true, i18n: true, ownAlternates: true },
  },
  // (languages: src/i18n). The English routes above stay unprefixed.
  {
    path: `/:lang(${PREFIXED_LOCALES.join("|")})`,
    name: "home-lang",
    component: () => import("@/HomePage.vue"),
    meta: { ghTheme: true, i18n: true },
  },
  {
    path: `/:lang(${PREFIXED_LOCALES.join("|")})/ticket`,
    name: "booking-details-lang",
    component: () => import("../TicketDetails.vue"),
    meta: { ghTheme: true, i18n: true, robots: "noindex, nofollow" },
  },
  {
    path: `/:lang(${PREFIXED_LOCALES.join("|")})/lisbon-visitor-pass`,
    name: "lisbon-visitor-pass-lang",
    component: () => import("../components/LisbonVisitorPassExplanation.vue"),
    meta: { ghTheme: true, i18n: true },
  },
  {
    path: `/:lang(${PREFIXED_LOCALES.join("|")})/portugal-dmc`,
    name: "portugal-dmc-lang",
    component: () => import("@/PortugalDMC.vue"),
    meta: { ghTheme: true, i18n: true },
  },
  {
    path: `/:lang(${PREFIXED_LOCALES.join("|")})/programmes/:slug`,
    name: "programme-lang",
    component: () => import(/* webpackChunkName: "programme" */ "@/ProgrammePage.vue"),
    meta: { ghTheme: true, i18n: true },
  },
  {
    path: '/guides/lisbon-3-day-itinerary',

    name: 'lisbon-3-day-itinerary',

    component: () =>
      import('@/components/TravelPostPage.vue'),

    props: {
      post: Lisbon3DayItinerary
    }
  },
  {
    path: "/lisbon-visitor-pass-feedback",
    name: "free-lisbon-visitor-pass-feedback",
    component: () => import("../Affiliates/FreeTicketWaitlist.vue"),
    meta: {
      title: 'Lisbon Visitor Pass Feedback | Guiders',
      description: 'Share your feedback about the Lisbon Visitor Pass experience. Help us improve our hop-on hop-off tuk-tuk service.',
      canonical: 'https://guiders.pt/lisbon-visitor-pass-feedback',
      robots: 'index, follow'
    }
  },
  {
    path: "/gallery",
    name: "gallery",
    component: () => import("../components/Gallery"),
    meta: {
      title: 'Tour Gallery | Guiders.pt',
      description: 'Browse photos from our previous tours and activities in Lisbon and Portugal. See real experiences from our travelers.',
      canonical: 'https://guiders.pt/gallery',
      robots: 'index, follow',
      og: {
        title: 'Tour Gallery | Guiders.pt',
        description: 'Photos from our tours in Portugal',
        url: 'https://guiders.pt/gallery'
      }
    }
  },
  {
    path: "/vendor/sell-ticket",
    name: "generate-ticket",
    component: () => import("../CreationFormComponents/VendorForm/VendorForm.vue"),
    meta: {
      requiresAuth: true,
      roles: ["vendor"],
      title: 'Sell Ticket | Vendor Dashboard',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/vendor/sell-ticket'
    }
  },
  {
    path: "/vendor/dashboard",
    name: "vendor-dashboard",
    component: () => import("../Vendor/Dasboard.vue"),
    meta: {
      requiresAuth: true,
      roles: ["vendor"],
      title: 'Vendor Dashboard | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/vendor/dashboard'
    }
  },
  /*  {
     path: "/",
     component: () => import("../components/HomePage"),
     meta: {
       title: 'Guiders.pt | Shared Tours and Activities in Portugal',
       description: 'Discover Portugal with our private tours, tuk-tuk rides, and custom itineraries. Book your perfect Portugal experience today!',
       keywords: 'lisbon tours, tuk-tuk tours, portugal guided tours, private tours lisbon, sintra tours',
       canonical: 'https://guiders.pt/',
       robots: 'index, follow',
       og: {
         title: 'Guiders.pt | Book Tours in Portugal',
         description: 'Discover Portugal with our guided tours',
         url: 'https://guiders.pt/'
       }
     }
   }, */
  {
    path: "/discover",
    name: "discover",
    component: () => import("../components/SearchResults"),
    meta: {
      title: 'Discover Tours | Guiders.pt',
      description: 'Search and discover the best tours and activities in Lisbon and Portugal. Filter by category, duration, and price.',
      canonical: 'https://guiders.pt/discover',
      robots: 'index, follow'
    }
  },
  {
    path: "/booking-success",
    name: "success",
    component: () => import("../components/BookingSuccess"),
    meta: {
      title: 'Booking Successful | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/booking-success'
    }
  },
  {
    path: "/vendor/booking-success",
    name: "vendor-booking-success",
    component: () => import("../components/VendorBookingSuccess"),
    meta: {
      requiresAuth: true,
      roles: ["vendor"],
      title: 'Booking Successful | Vendor',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/vendor/booking-success'
    }
  },
  {
    path: "/settings/basic-information",
    name: "settings-basic-information",
    component: () => import("../Settings/GeneralInfo"),
    meta: {
      requiresAuth: true,
      title: 'Basic Information | Settings',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/settings/basic-information'
    },
  },
  {
    path: "/guide-settings",
    name: "guide-settings",
    component: () => import("../Settings/Settings"),
    meta: {
      requiresAuth: true,
      isGuider: true,
      title: 'Guide Settings | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/guide-settings'
    },
  },
  {
    path: "/guider",
    name: "guider",
    component: () => import("../Guiders/Guider"),
    meta: {
      requiresAuth: true,
      isGuider: true,
      title: 'Guider Dashboard | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/guider'
    },
    children: [
      {
        path: 'dashboard',
        name: 'guider-dashboard',
        component: Dashboard,
        meta: {
          title: 'Dashboard | Guider Portal',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/guider/dashboard'
        }
      },
      {
        path: 'upcoming',
        name: 'guider-upcoming-activities',
        component: UpcomingActivitiesPage,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Upcoming Activities | Guider',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/guider/upcoming'
        },
      },
      {
        path: "activity/:activityId/group/:activityGroupId/start",
        name: "start-activity",
        component: CreateGroup,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Start Activity | Guider',
          robots: 'noindex, nofollow',
          canonical: (route) => `https://guiders.pt/guider/activity/${route.params.activityId}/group/${route.params.activityGroupId}/start`
        },
      },
      {
        path: "settings",
        name: "guider-settings",
        component: Settings,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Settings | Guider',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/guider/settings'
        },
      },
      {
        path: "settings/basic-information",
        name: "guider-basic-information",
        component: GeneralInfo,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Basic Information | Guider',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/guider/settings/basic-information'
        },
      },
      {
        path: "settings/change-password",
        name: "guider-change-password",
        component: ChangePassword,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Change Password | Guider',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/guider/settings/change-password'
        },
      },
      {
        path: "/scan-ticket",
        name: "scan-ticket",
        component: TicketScanner,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Scan Ticket | Guider',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/scan-ticket'
        },
      },
    ],
  },
  {
    path: "/guider/login",
    name: "signin-guider",
    component: () => import("../components/Login"),
    meta: {
      requiresUnauth: true,
      title: 'Guider Login | Guiders',
      description: 'Login to your guider account to manage tours, bookings, and settings.',
      canonical: 'https://guiders.pt/guider/login',
      robots: 'noindex, nofollow'
    },
  },
  {
    path: "/guider/stripe-dashboard",
    name: "stripe-dashboard",
    component: () => import("../Guiders/StripeDashboard"),
    meta: {
      requiresAuth: true,
      title: 'Stripe Dashboard | Guider',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/guider/stripe-dashboard'
    },
  },
  {
    path: "/company",
    name: "company",
    component: () => import("../Company/Company"),
    meta: {
      requiresAuth: true,
      isGuider: true,
      title: 'Company Portal | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/company'
    },
    children: [
      {
        path: 'dashboard',
        name: 'company-dashboard',
        component: CompanyDashboard,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Dashboard | Company Portal',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/company/dashboard'
        },
      },
      {
        name: 'schedule',
        path: "schedule",
        component: SchedulePlanner,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Schedule Planner | Company',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/company/schedule'
        },
      },
      {
        path: 'upcoming',
        name: 'company-upcoming-activities',
        component: UpcomingActivitiesPage,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Upcoming Activities | Company',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/company/upcoming'
        },
      },
      {
        path: 'employees',
        name: 'employees',
        component: EmployeesPage,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Employees | Company',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/company/employees'
        },
      },
      {
        path: 'add-employee',
        name: 'add-employee',
        component: AddEmployee,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Add Employee | Company',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/company/add-employee'
        },
      },
      {
        path: '/:employeeId/manage-employee',
        name: 'manage-employee',
        component: ManageEmployee,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Manage Employee | Company',
          robots: 'noindex, nofollow',
          canonical: (route) => `https://guiders.pt/company/${route.params.employeeId}/manage-employee`
        },
      },
      {
        path: "settings",
        name: "company-settings",
        component: Settings,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Settings | Company',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/company/settings'
        },
      },
      {
        path: "settings/basic-information",
        name: "company-basic-information",
        component: GeneralInfo,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Basic Information | Company',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/company/settings/basic-information'
        },
      },
      {
        path: "settings/profile",
        name: "company-profile",
        component: CompanyProfile,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Profile | Company',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/company/settings/profile'
        },
      },
      {
        path: "settings/change-password",
        name: "company-change-password",
        component: ChangePassword,
        meta: {
          requiresAuth: true,
          isGuider: true,
          title: 'Change Password | Company',
          robots: 'noindex, nofollow',
          canonical: 'https://guiders.pt/company/settings/change-password'
        },
      },
    ],
  },
  {
    path: "/:activityGroup/details",
    name: "activity-group-details",
    component: () => import("../Admin/ActivityGroupDetails"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Activity Group Details | Admin',
      robots: 'noindex, nofollow',
      canonical: (route) => `https://guiders.pt/${route.params.activityGroup}/details`
    },
  },
  {
    path: "/admin/affiliates",
    name: "affiliates-program",
    component: AffiliateProgram,
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Affiliate Program | Admin',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/affiliates'
    },
  },
  {
    path: "/affiliate/dashboard",
    name: "affiliate-dashboard",
    component: () => import("../Affiliates/Dashboard.vue"),
    meta: {
      // Signed in (the affiliate role is only known right after sign-up)
      requiresAuth: true,
      title: 'Affiliate Dashboard | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/affiliate/dashboard'
    }
  },
  {
    path: "/affiliate/set-up-payment",
    name: "affiliates-set-up-stripe",
    component: () => import("../Affiliates/SetUpStripeAccount.vue"),
    meta: {
      // Signed in (the affiliate role is only known right after sign-up)
      requiresAuth: true,
      title: 'Set Up Payment | Affiliate',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/affiliate/set-up-payment'
    }
  },
  {
    path: "/admin/add-vendor",
    name: "add-vendor",
    component: () => import("../Admin/AddVendorForm"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Add Vendor | Admin',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/add-vendor'
    }
  },
  {
    path: "/admin/dashboard",
    name: "admin-dashboard",
    component: AdminDashboard,
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Admin Dashboard | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/dashboard'
    },
  },
  {
    path: "/admin/guiders",
    name: "manage-guiders",
    component: ManageGuiders,
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Manage Guiders | Admin',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/guiders'
    },
  },
  {
    path: "/admin/payments",
    name: "manage-payments",
    component: ManagePayments,
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Manage Payments | Admin',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/payments'
    },
  },
  {
    path: "/admin/guiders/:guiderUid",
    name: "guider-details",
    component: GuiderDetails,
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Guider Details | Admin',
      robots: 'noindex, nofollow',
      canonical: (route) => `https://guiders.pt/admin/guiders/${route.params.guiderUid}`
    },
  },
  {
    path: "/admin/vendors/:vendorId",
    name: "vendor-details",
    component: () => import("../Admin/VendorDetails.vue"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Vendor Details | Admin',
      robots: 'noindex, nofollow',
      canonical: (route) => `https://guiders.pt/admin/vendors/${route.params.vendorId}`
    },
  },
  {
    path: "/admin/upcoming",
    name: "upcoming-activities",
    component: UpcomingActivitiesPage,
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Upcoming Activities | Admin',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/upcoming'
    },
  },
  {
    path: "/admin/activities/edit/:id",
    name: "edit-activity",
    component: () => import("../components/CreateTour"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Edit Activity | Admin',
      robots: 'noindex, nofollow',
      canonical: (route) => `https://guiders.pt/admin/activities/edit/${route.params.id}`
    },
    beforeRouteLeave: (to, from, next) => {
      const answer = window.confirm('Do you really want to leave? You have unsaved changes!')
      if (answer) {
        next()
      } else {
        next(false)
      }
    }
  },
  {
    path: "/admin/activities/create",
    name: "add-activity",
    component: CreateTour,
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Create Activity | Admin',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/activities/create'
    },
  },
  {
    path: "/admin/event/edit/:id",
    name: "edit-event",
    component: () => import("../components/CreateEvent"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Edit Event | Admin',
      robots: 'noindex, nofollow',
      canonical: (route) => `https://guiders.pt/admin/event/edit/${route.params.id}`
    },
    beforeRouteLeave: (to, from, next) => {
      const answer = window.confirm('Do you really want to leave? You have unsaved changes!')
      if (answer) {
        next()
      } else {
        next(false)
      }
    }
  },
  {
    path: "/admin/event/create",
    name: "create-event",
    component: CreateEvent,
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Create Event | Admin',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/event/create'
    },
  },
  {
    path: "/admin/ticket/create",
    name: "create-ticket",
    component: CreateTicket,
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Create Ticket | Admin',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/admin/ticket/create'
    },
  },
  {
    path: "/admin/ticket/edit/:id",
    name: "edit-ticket",
    component: () => import("../components/CreateTicket"),
    meta: {
      requiresAuth: true,
      isAdmin: true,
      title: 'Edit Ticket | Admin',
      robots: 'noindex, nofollow',
      canonical: (route) => `https://guiders.pt/admin/ticket/edit/${route.params.id}`
    },
    beforeRouteLeave: (to, from, next) => {
      const answer = window.confirm('Do you really want to leave? You have unsaved changes!')
      if (answer) {
        next()
      } else {
        next(false)
      }
    }
  },
  {
    path: "/details/:id/:title?",
    name: "details",
    component: () => import("../components/TourPage"),
    meta: {
      ghTheme: true, // Guiders design: own header/footer, see components/home/GhPage.vue
      // Translated from Firestore (tour.translations); the page sets its own
      // hreflang links, only for languages the tour is translated into
      i18n: true,
      ownAlternates: true,
      requiresAuth: false,
      title: (route) => `${route.params.title ? route.params.title.replace(/-/g, ' ') : 'Tour Details'} | Guiders.pt`,
      description: (route) => `Book "${route.params.title ? route.params.title.replace(/-/g, ' ') : 'this amazing tour'}" in Portugal. Experience the best guided tours with local experts.`,
      keywords: (route) => `${route.params.title ? route.params.title.replace(/-/g, ', ') : 'tour, lisbon, portugal'}, guided tour, book tour`,
      canonical: (route) => {
        const baseUrl = 'https://guiders.pt';
        if (route.params.title) {
          const cleanTitle = route.params.title.toLowerCase().replace(/\s+/g, '-');
          return `${baseUrl}/details/${route.params.id}/${cleanTitle}`;
        }
        return `${baseUrl}/details/${route.params.id}`;
      },
      robots: 'index, follow',
      og: {
        title: (route) => `${route.params.title ? route.params.title.replace(/-/g, ' ') : 'Tour'} | Guiders.pt`,
        description: (route) => `Book "${route.params.title ? route.params.title.replace(/-/g, ' ') : 'this tour'}" in Portugal`,
        url: (route) => {
          const baseUrl = 'https://guiders.pt';
          if (route.params.title) {
            const cleanTitle = route.params.title.toLowerCase().replace(/\s+/g, '-');
            return `${baseUrl}/details/${route.params.id}/${cleanTitle}`;
          }
          return `${baseUrl}/details/${route.params.id}`;
        }
      }
    },
    props: true
  },
  {
    path: '/ride-test',
    name: "ride-test",
    component: () => import('../components/RideTestDashboard.vue'),
    meta: {
      requiresAuth: true,
      title: 'Ride Test | Driver',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/ride-test'
    }
  },
  {
    path: '/trip-management',
    name: 'trip-management',
    component: () => import('../Vendor/TripManagement.vue'),
    meta: {
      requiresAuth: true,
      roles: ["vendor"],
      title: 'Trip Management | Vendor',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/trip-management'
    }
  },
  // Visitor Pass pickups: the driver's shift and seats (vendor accounts
  // with role "Driver"; the backend checks the role)
  {
    path: '/driver',
    name: 'driver',
    component: () => import(/* webpackChunkName: "driver" */ '../Vendor/DriverShift.vue'),
    meta: {
      requiresAuth: true,
      roles: ["vendor"],
      title: 'Driver | Guiders',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/driver'
    }
  },
  {
    path: "/event/:eventId/details/:id/:title?",
    name: "event-details",
    component: () => import("../components/TourPage"),
    meta: {
      title: (route) => `${route.params.title ? route.params.title.replace(/-/g, ' ') : 'Event Details'} | Guiders.pt`,
      description: (route) => `Book tickets for "${route.params.title ? route.params.title.replace(/-/g, ' ') : 'this event'}" in Portugal.`,
      canonical: (route) => {
        const baseUrl = 'https://guiders.pt';
        if (route.params.title) {
          const cleanTitle = route.params.title.toLowerCase().replace(/\s+/g, '-');
          return `${baseUrl}/event/${route.params.eventId}/details/${route.params.id}/${cleanTitle}`;
        }
        return `${baseUrl}/event/${route.params.eventId}/details/${route.params.id}`;
      },
      robots: 'index, follow'
    },
  },
  {
    path: "/frequently-asked-questions",
    name: "questions",
    component: () => import("../components/FrequentlyAskedQuestions.vue"),
    meta: {
      title: 'Frequently Asked Questions | Guiders.pt',
      description: 'Find answers to common questions about booking tours, cancellation policies, payment methods, and our services in Portugal.',
      keywords: 'faq, frequently asked questions, tour booking questions, cancellation policy, payment methods',
      canonical: 'https://guiders.pt/frequently-asked-questions',
      robots: 'index, follow',
      og: {
        title: 'Frequently Asked Questions | Guiders.pt',
        description: 'Answers to common questions about our tours and services',
        url: 'https://guiders.pt/frequently-asked-questions'
      }
    },
  },
  {
    path: "/review",
    name: "review",
    component: TourReview,
    meta: {
      title: 'Review your experience | Guiders.pt',
      description: 'Tell us how your Guiders tour went.',
      canonical: 'https://guiders.pt/review',
      // A feedback form, not a page people should find in search
      robots: 'noindex, follow',
    },
  },
  {
    path: "/affiliates",
    name: "affiliates",
    component: AffiliatesPage,
    meta: {
      title: 'Become an Affiliate | Guiders.pt',
      description: 'Join our affiliate program and earn commissions by recommending Guiders tours. Partner with us to grow your income.',
      keywords: 'affiliate program, earn commissions, travel affiliate, tour affiliate program',
      canonical: 'https://guiders.pt/affiliates',
      robots: 'index, follow',
      og: {
        title: 'Become an Affiliate | Guiders.pt',
        description: 'Earn commissions by recommending our tours',
        url: 'https://guiders.pt/affiliates'
      }
    },
  },
  {
    path: "/affiliate/:accountId",
    name: "affiliateStripeRefresh",
    component: StripeRefresh,
    meta: {
      title: 'Stripe Account Refresh | Affiliate',
      robots: 'noindex, nofollow',
      canonical: (route) => `https://guiders.pt/affiliate/${route.params.accountId}`
    }
  },
  {
    path: "/guide/registration",
    name: "registration",
    component: RegistrationForm,
    meta: {
      title: 'Become a Tour Guide in Portugal | Guiders.pt',
      description: 'Join Guiders as a professional tour guide in Portugal. Work with travelers, share your expertise, and grow your business.',
      keywords: 'become a tour guide, tour guide registration, work as a guide in portugal, tour operator partnership',
      canonical: 'https://guiders.pt/guide/registration',
      robots: 'index, follow',
      og: {
        title: 'Become a Tour Guide in Portugal | Guiders.pt',
        description: 'Join our network of professional tour guides',
        url: 'https://guiders.pt/guide/registration'
      }
    },
  },
  {
    path: "/transfer/registration",
    name: "transfer-registration",
    component: TranferRegistrationForm,
    meta: {
      title: 'Transfer Service Registration | Guiders.pt',
      description: 'Register your transfer service with Guiders. Partner with us to provide airport transfers and transportation services in Portugal.',
      keywords: 'transfer service registration, airport transfers portugal, transportation partnership, driver registration',
      canonical: 'https://guiders.pt/transfer/registration',
      robots: 'index, follow',
      og: {
        title: 'Transfer Service Registration | Guiders.pt',
        description: 'Partner with us for transfer services in Portugal',
        url: 'https://guiders.pt/transfer/registration'
      }
    },
  },
  {
    path: "/feedback",
    name: "feedback",
    component: FeedbackForm,
    meta: {
      title: 'Feedback Form | Guiders.pt',
      description: 'Share your feedback on our personalized travel services in Portugal. Help us improve our private guided tours, transport services, and custom itineraries.',
      keywords: 'feedback, tour feedback, service review, customer feedback portugal',
      canonical: 'https://guiders.pt/feedback',
      robots: 'index, follow',
      og: {
        title: 'Feedback Form | Guiders.pt',
        description: 'Share your feedback on our travel services',
        url: 'https://guiders.pt/feedback'
      }
    },
  },
  {
    path: "/sign-up-as-private-guide",
    name: "private-guide-form",
    component: RegisteredPrivateGuideForm,
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
    meta: {
      title: 'Page Not Found | Guiders.pt',
      robots: 'noindex, nofollow',
      canonical: 'https://guiders.pt/404'
    }
  },
];

// --- Everything below this line is browser/runtime-only. ---
// It's guarded so that Node build scripts (e.g. the sitemap generator) can
// `require`/`import` this file just for the plain `routes` array above,
// without instantiating a real Vue Router, touching the Vuex store, or
// registering navigation guards.
let router;

if (typeof window !== 'undefined') {
  // Initialize referral tracking
  store.dispatch(AffiliatesActions.INIT_REFERRAL);

  router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    // Without this the router keeps the scroll position between pages, so a
    // link clicked low on one page opened the next page near its bottom.
    scrollBehavior(to, from, savedPosition) {
      // Back/forward: return to where the visitor was
      if (savedPosition) return savedPosition;
      // Same page (only #section or query changed): leave scrolling to the
      // browser and the page's own anchor handling
      if (to.path === from.path) return false;
      // Same page in another language: stay where the visitor was
      if (splitLocalePath(to.path).path === splitLocalePath(from.path).path) return false;
      // New page with #section: the page scrolls to it itself once loaded
      if (to.hash) return false;
      // Any other new page: start at the top
      return { x: 0, y: 0 };
    },
    parseQuery(query) {
      const parsed = {};
      const pairs = (query[0] === '?' ? query.slice(1) : query).split('&');
      pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        if (key) {
          parsed[decodeURIComponent(key)] = value ? decodeURIComponent(value) : '';
        }
      });
      return parsed;
    },
    stringifyQuery(query) {
      const cleanQuery = {};
      // Filter out empty, undefined, and null values
      Object.keys(query).forEach(key => {
        if (query[key] !== undefined && query[key] !== null && query[key] !== '') {
          cleanQuery[key] = query[key];
        }
      });

      const queryString = Object.keys(cleanQuery)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(cleanQuery[key])}`)
        .join('&');

      return queryString ? `?${queryString}` : '';
    }
  });

  // Language: /pt/... pages show Portuguese, everything else English.
  // The language file is loaded before the page renders.
    router.beforeEach(async (to, from, next) => {
    if (to.meta.i18n) {
      if (to.params.lang) {
        // Visiting a translated page = this is the visitor's language
        saveLanguagePreference(to.params.lang);
      } else {
        // English address of a translated page: send visitors who chose
        // another language to their version
        const preferred = getLanguagePreference();
        if (preferred && preferred !== DEFAULT_LOCALE) {
          next({ path: localePath(to.path, preferred), query: to.query, hash: to.hash, replace: true });
          return;
        }
      }
    }

    const lang = to.meta.i18n && to.params.lang ? to.params.lang : DEFAULT_LOCALE;
    try {
      await loadLocale(lang);
      i18n.locale = lang;
    } catch (error) {
      console.error(`Couldn't load language "${lang}"`, error);
      i18n.locale = DEFAULT_LOCALE;
    }
    next();
  });

  router.beforeEach((to, from, next) => {
    if (to.query.fbclid || navigator.userAgent.includes('Facebook')) {
      // Remove Meta parameters and redirect to clean URL
      const cleanQuery = { ...to.query };
      delete cleanQuery.fbclid;
      delete cleanQuery.fb_action_ids;

      if (Object.keys(cleanQuery).length === 0) {
        next(to.path);
      } else {
        next({ path: to.path, query: cleanQuery });
      }
      return;
    }

    // 1. Capture referral
    store.dispatch(AffiliatesActions.CAPTURE_REFERRAL, to);

    // 2. Authentication & authorization. The signed-in user and their roles
    // are kept in the store (saved in the browser, so they survive a
    // refresh). This only controls which screens open: the data itself must
    // stay protected by the Firestore security rules.
    const userState = store.state.users;
    const isSignedIn = hasSignedInUser(userState);
    const roleMap = {
      admin: userState[UsersStates.IS_ADMIN],
      vendor: userState[UsersStates.IS_VENDOR],
      guider: userState[UsersStates.IS_COMPANY] || userState[UsersStates.IS_EMPLOYEE],
      affiliate: userState[UsersStates.IS_AFFILIATE],
      privateGuide: userState[UsersStates.IS_PRIVATE_GUIDE],
    };
    // Child pages (e.g. /company/dashboard) inherit their parent's rules
    const needs = (key) => to.matched.some(record => record.meta[key]);
    const requiredRoles = to.matched.flatMap(record => record.meta.roles || []);

    // Private pages: sign in first
    if ((needs("requiresAuth") || needs("isAdmin") || requiredRoles.length) && !isSignedIn) {
      // Some areas have their own login page (e.g. the guide portal)
      const own = to.matched.find(record => record.meta.loginRoute);
      return next({ name: own ? own.meta.loginRoute : "login-form", query: { redirect: to.fullPath } });
    }

    // Admin pages: admins only
    if (needs("isAdmin") && !roleMap.admin) {
      return next("/");
    }

    // 3. Role-based access (admins may open every role's pages)
    if (requiredRoles.length && !roleMap.admin && !requiredRoles.some(role => roleMap[role])) {
      return next("/");
    }

    // Login/registration pages when already signed in: go to your dashboard
    if (needs("requiresUnauth") && isSignedIn) {
      const dashboard = dashboardRouteFor(userState);
      if (dashboard) return next({ name: dashboard });
    }

    // 4. All good, continue
    next();
  });

  // Add referral to all navigation
    // Open tabs pick up new deploys (version check + missing-file reload)
  installAppUpdates(router);

  const originalPush = VueRouter.prototype.push;
  VueRouter.prototype.push = function push(location) {
    if (typeof location === 'object') {
      const referral = store.getters[AffiliatesGetters.GET_REFERRAL];
      if (referral) {
        // Clean existing query first
        const cleanQuery = {};
        if (location.query) {
          Object.keys(location.query).forEach(key => {
            if (location.query[key] !== undefined &&
              location.query[key] !== null &&
              location.query[key] !== '') {
              cleanQuery[key] = location.query[key];
            }
          });
        }

        // Only add referral if it's not already present
        if (!cleanQuery.referral) {
          cleanQuery.referral = referral;
        }

        location.query = cleanQuery;
      }
    }
    return originalPush.call(this, location);
  };
}

export default router;